// ResponsiveProvider.tsx
import React, { createContext, useContext } from 'react';

import { useMediaQuery } from '@mui/material';

const breakpoints = {
  mobile: 0,
  tablet: 600,
  laptop: 1024,
  desktop: 1440,
};

type DeviceType = 'mobile' | 'tablet' | 'laptop' | 'desktop';

interface ResponsiveContextValue {
  isMobile: boolean;
  isTablet: boolean;
  isLaptop: boolean;
  isDesktop: boolean;
  device: DeviceType;
}

const ResponsiveContext = createContext<ResponsiveContextValue | null>(null);

export const ResponsiveProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const isMobile = useMediaQuery(`(max-width:${breakpoints.tablet - 1}px)`);
  const isTablet = useMediaQuery(
    `(min-width:${breakpoints.tablet}px) and (max-width:${breakpoints.laptop - 1}px)`
  );
  const isLaptop = useMediaQuery(
    `(min-width:${breakpoints.laptop}px) and (max-width:${breakpoints.desktop - 1}px)`
  );
  const isDesktop = useMediaQuery(`(min-width:${breakpoints.desktop}px)`);

  let device: DeviceType = 'mobile';
  if (isTablet) device = 'tablet';
  else if (isLaptop) device = 'laptop';
  else if (isDesktop) device = 'desktop';

  return (
    <ResponsiveContext.Provider
      value={{
        isMobile,
        isTablet,
        isLaptop,
        isDesktop,
        device,
      }}
    >
      {children}
    </ResponsiveContext.Provider>
  );
};

export function useResponsive() {
  const ctx = useContext(ResponsiveContext);
  if (!ctx)
    throw new Error('useResponsive must be used within ResponsiveProvider');
  return ctx;
}
